"use strict";
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    Object.defineProperty(o, k2, { enumerable: true, get: function() { return m[k]; } });
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (Object.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.FormAnchorProvider = void 0;
const react_1 = __importStar(require("react"));
const form_anchor_context_1 = require("./form-anchor-context");
function FormAnchorProvider({ children }) {
    const formAnchorRef = react_1.useRef(null);
    return (react_1.default.createElement(form_anchor_context_1.FormAnchorContext.Provider, { value: { formAnchorRef } },
        react_1.default.createElement("div", { ref: formAnchorRef }),
        children));
}
exports.FormAnchorProvider = FormAnchorProvider;
//# sourceMappingURL=form-anchor-provider.js.map